import { Compass, Heart, RotateCcw, UtensilsCrossed } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    icon: Compass,
    num: "01",
    title: "Explore",
    text: "Find restaurants nearby or search places at your next destination. Browse local favorites, hidden gems, and new spots that catch your interest.",
  },
  {
    icon: Heart,
    num: "02",
    title: "Save & Plan",
    text: "Save restaurants you'd like to try and keep your next dining ideas organized. Going with someone? Invite family or friends and coordinate your outing.",
  },
  {
    icon: UtensilsCrossed,
    num: "03",
    title: "Visit & Enjoy",
    text: "Head out, try something delicious, and enjoy the moment. Whether dining solo, on a date, or with friends, make every outing your own experience.",
  },
  {
    icon: RotateCcw,
    num: "04",
    title: "Remember & Revisit",
    text: "Build your personal dining history, add notes, and share reviews of places you've tried. Revisit your favorites and remember what made each experience special.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="scroll-mt-24 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-crave-gold">How It Works</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-crave-cream sm:text-5xl">
          From Craving to Table in Four Steps
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-crave-muted">
          Built to get you out experiencing restaurants — not just collecting recommendations.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-10 lg:grid-cols-4">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.12}>
            <div data-testid={`how-it-works-step-${i + 1}`} className="relative pt-10">
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -top-8 left-0 select-none font-display text-8xl font-semibold text-white/5"
              >
                {step.num}
              </span>
              <div className="relative">
                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-crave-gold/30 bg-crave-gold/10 text-crave-gold">
                  <step.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-6 font-display text-2xl font-medium tracking-tight text-crave-cream sm:text-3xl">
                  {step.title}
                </h3>
                <p className="mt-3 max-w-sm text-base leading-relaxed text-crave-muted">{step.text}</p>
              </div>
              {i < STEPS.length - 1 && (
                <div
                  aria-hidden="true"
                  className="absolute right-0 top-16 hidden h-px w-10 bg-gradient-to-r from-crave-gold/40 to-transparent md:block"
                />
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
